/* derives loading state for cost savings chart */
export const deriveLoadingPercentage = (loadingStates: boolean[]): { fetched: number; total: number } => {
  const total = loadingStates.length
  const fetched = loadingStates.filter(d => !d).length

  return { total, fetched }
}
